import React, { Component } from 'react';
import { Helmet } from "react-helmet";
// import { FaFacebook, FaInstagram } from 'react-icons/fa';
import * as util from '../../utils/util';
import { getTodayDate } from '../../utils/util';
import html2canvas from 'html2canvas';
import Responsive from 'react-responsive';
import ContentEditable from 'react-contenteditable';
import LoadingBlock from '../../components/common/LoadingBlock';
import { isJSON } from '../../utils/util';
import '../../components/onboarding/StickyHeader.css';
import '../recommendations/Recommendations.css';
import '../recommendations/RecommendationsAdditionalCategories.css';
import '../recommendations/RecommendationsBundle.css';

import './showThank.css';

import Api from '../../utils/api';

const quoteArr = [
  "“Love yourself. It is important to stay positive because beauty comes from the inside out.” —Jenn Proske, Canadian Actress",
  "“Find your own way, have an open spirit, and believe in your own beauty.” —Francois Nars, French Businessman",
  "“Beauty is power; a smile is its sword.” —John Ray, English Environmentalist ",
  "“Beauty is when you can appreciate yourself. When you love yourself, that's when you're most beautiful.” —Zoe Kravitz, American Actress",
  "“Imperfection is beauty, madness is genius and it's better to be absolutely ridiculous than absolutely boring.” —Marilyn Monroe, American Actress",
  "“Beauty is being comfortable and confident in your own skin.” —Iman, Somali-American Model and Actress"
];

class showThankYou extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderEnd: false,
      orderId: '',
      orderSubtotal: 0,
      clickId: '',
      skinType: null,
      showDummyDiv: false,
      name: '',
      skinImageExists: true,
      loading: false,
      selectedOrderForRegimenCard:[],
      isOrderValue: false,
      contactInformation_email:'',
      contactInformation_lastName:'',
      contactInformation_firstName:'',
      orderForInfo:[],
    }
  }
  componentDidMount() {

    if (this.props.location != undefined && this.props.location.state != undefined) {
      if(localStorage.getItem("auth_token")){
        this.getCustomerInfo();
      }else{

        let contactInformation_info = localStorage.getItem("contactInformation_info");
        if(isJSON(contactInformation_info)){
            let contactInformationJson = {};
            try {
                contactInformationJson = JSON.parse(contactInformation_info);
                this.setState({
                    contactInformation_email: contactInformationJson['contactInformation_email'],
                    contactInformation_lastName: contactInformationJson['contactInformation_lastName'],
                    contactInformation_firstName: contactInformationJson['contactInformation_firstName'],
                })
            } catch (error) {
                contactInformationJson = {}
            }
        }

        this.getRegimenCard()
        this.setState({
          showDummyDiv: true
        })
      }
      
      this.setState({
        orderId: this.props.location.state.orderId,
        orderSubtotal: this.props.location.state.orderSubtotal,
        orderEnd: true,
        selectedOrderForRegimenCard: this.props.location.state.orderProductsData,
        sourceOrderId: this.props.location.state.sourceOrderId,
        isOrderValue: true,
      })

      this.fun_gtmOrderInfo_track();
     
    }

    window.onbeforeunload = function(){
      if(this.props.location != undefined && this.props.location.state != undefined){
        if(this.state.loading){
          return "Please do not close this page until your order is finalized."; 
        }
      }
    }

    try {
      window.fbq('track', 'Purchase', {
        total_paid_customer: this.props.location.state.orderSubtotal,
        number: this.props.location.state.orderGoodsNumber,
        orderId:this.state.orderId,
        userEmail: localStorage.getItem("user_global_email") ? localStorage.getItem("user_global_email") : this.state.contactInformation_email
      })
    } catch (error) {
    }

  }

  cancelLoading(isDone) {
    if (!isDone) {
      console.log('regimen card err')
    }
    this.setState({
      loading: false
    })
  }

  fun_gtmOrderInfo_track(){
    var dataLayer  = window.dataLayer || [];
    dataLayer.push({
      'event': 'transaction',
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': this.props.location.state.orderId,        // Transaction ID. Required           
            'affiliation': 'helloava-app',
            'revenue': this.props.location.state.orderSubtotal,   // Total transaction value (incl. tax and shipping)
            'tax': this.props.location.state.tax,
            'shipping': this.props.location.state.shippingRate,
            'coupon': this.props.location.state.promoCodeSaved   // Optional fields may be omitted or set to empty string.
          },
        'products': this.props.location.state.gtmORderInfoTrack
        }
      }
    });
  }

  renderRegimenCardText() {
    // if (this.state.selectedOrderForRegimenCard.length) {
    const categoryOrderDaily = {
      "make-up remover": 1,
      "cleanser": 2,
      "toner": 3,
      "serum": 4,
      "moisturizer": 5,
      "eye cream": 6,
      "treatment": 7,
      "spf": 8,
      "supplement": 9
    };

    const categoryOrderWeekly = {
      "exfoliator": 1,
      "mask": 2
    }
    let productsType = [];
    let regimenTextDaily = [];
    let regimenTextWeekly = [];
    this.state.selectedOrderForRegimenCard.forEach((orderedProduct) => {
      if (orderedProduct.type.toLowerCase() === "exfoliator" || orderedProduct.type.toLowerCase() === "mask") {
        regimenTextWeekly.push({ name: orderedProduct.name, type: orderedProduct.type });
      } else {
        regimenTextDaily.push({ name: orderedProduct.name, type: orderedProduct.type });
      }
      try {
        productsType.push(orderedProduct.type.toLowerCase());
      } catch (error) {}
    });

    regimenTextDaily.sort((a, b) => {
      return categoryOrderDaily[a.type.toLowerCase()] - categoryOrderDaily[b.type.toLowerCase()];
    });

    regimenTextWeekly.sort((a, b) => {
      return categoryOrderWeekly[a.type.toLowerCase()] - categoryOrderDaily[b.type.toLowerCase()];
    });

  

let regimenTextDailyRender = [];

 var _type_L;
 var makeArray = [],cleanserArray =[],tonerArray = [],serumArray = [],treatmentArray = [],moisturizerArray = [],eyeArray = [],spfArray = [],supplementArray = [];
 regimenTextDaily.map(order => {
    _type_L = order.type.toLowerCase();
      if (_type_L === "make-up remover"){
        makeArray.push(order.name);
      }else if(_type_L === "cleanser"){
        cleanserArray.push(order.name);
      }else if (_type_L === "toner") {
        tonerArray.push(order.name);
      }else if (_type_L === "serum") {
        serumArray.push(order.name);
      }else if (_type_L === "treatment"){
        treatmentArray.push(order.name);
      }else if (_type_L === "moisturizer"){
        moisturizerArray.push(order.name);
      }else if (_type_L === "eye cream"){
        eyeArray.push(order.name);
      }else if (_type_L === "spf"){
        spfArray.push(order.name);
      }else{
        supplementArray.push(order.name);
      }
});

 if(makeArray.length >= 1){
    regimenTextDailyRender.push(`Remove make-up with ${makeArray.join(" or ")} (night)`);
 }

 if(cleanserArray.length >= 1){
    regimenTextDailyRender.push(`Cleanse with ${cleanserArray.join(" or ")} (day + night)`);
 }else{
    regimenTextDailyRender.push('Cleanse with your own cleanser (day + night)');
 }

 if(tonerArray.length >= 1){
    regimenTextDailyRender.push(`Tone with ${tonerArray.join(" or ")} (day + night)`);
 }

 if(serumArray.length >= 1){
    regimenTextDailyRender.push(`Treat with ${serumArray.join(" or ")} (day + night)`);
 }else{
    regimenTextDailyRender.push('Treat with your own serum (day+night)');
 }

 if(treatmentArray.length >= 1){
    regimenTextDailyRender.push(`Treat with ${treatmentArray.join(" or ")} (night)`);
 }

 if(moisturizerArray.length >= 1){
    regimenTextDailyRender.push(`Hydrate with ${moisturizerArray.join(" or ")} (day + night)`);
 }else{
    regimenTextDailyRender.push('Hydrate with your own moisturizer (day + night)');
 }

 if(eyeArray.length >= 1){
    regimenTextDailyRender.push(`Apply ${eyeArray.join(" or ")} on your under-eye area (day + night)`);
 }

 if(spfArray.length >=1){
    regimenTextDailyRender.push(`Protect with ${spfArray.join(" or ")} (day + night)`);
 }else{
    regimenTextDailyRender.push('Protect with your own SPF (day)');
 }

 if(supplementArray.length >=1){
    regimenTextDailyRender.push(`Take the ${supplementArray.join(" or ")} supplement (read instructions)`);
 }

    let regimenTextWeeklyRender = [],exfoliatorArray = [],pamperArray = []
    regimenTextWeekly.map(order => {
      const type = order.type.toLowerCase();
      if (type === "exfoliator"){
        exfoliatorArray.push(order.name);
      } 
      else {
        pamperArray.push(order.name);
      } 
    });

    if(exfoliatorArray.length >=1){
        regimenTextWeeklyRender.push(`Exfoliate once a week with ${exfoliatorArray.join(" or ")} (night)`)
    }

    if(pamperArray.length >=1){
        regimenTextWeeklyRender.push(`Pamper yourself with ${pamperArray.join(" or ")} (night)`)
    }


    var regimenClass = "regimen-text";
    if ((regimenTextDailyRender.length + regimenTextWeeklyRender.length) >= 6) {
      regimenClass = "regimen-text-long-conten-8";
    } else if ((regimenTextDailyRender.length + regimenTextWeeklyRender.length) >= 10) {
      regimenClass = "regimen-text-long-conten-6";
    }

    var regimenTextDailyRenderString = "";
    regimenTextDailyRender.forEach((element,key) => {
      regimenTextDailyRenderString+= `<li class="regimen-datail-li"> <div class="regimen-datail-li-serialNumber">${key+1}.</div> <div class="regimen-datail-li-conten">${element}<div> </li>`
    });
    var regimenTextWeeklyRenderString = "";
    regimenTextWeeklyRender.forEach((element,key) => {
      regimenTextWeeklyRenderString+= `<li class="regimen-datail-li"> <div class="regimen-datail-li-serialNumber">${key+1}.</div> <div class="regimen-datail-li-conten">${element}<div> </li>`
    });


    let regimenString = `<div class= ${regimenClass} ><div class="regimen-text-title">${regimenTextDailyRender.length > 0 ? "Daily" : ""}</div><ol class="daily regimen-datail">${regimenTextDailyRenderString}</ol><div className="regimen-text-title">${regimenTextWeeklyRender.length > 0 ? "Weekly" : ""}</div><ol class="weekly regimen-datail">${regimenTextWeeklyRenderString}</ol></div>`;
    let regimenStringOutput = regimenString.replace(",", "").replace(/,/g, '').trim();

    //If New Order
    this.setState({ editHtmlOriginal: regimenStringOutput });
    if (this.state.editHtml === "") this.setState({ editHtml: regimenStringOutput });

  } //end
  //renderRegimenCardText end

  // getRegimenCard() {
  //   const orderId = this.state.orderId2;
  //   fetch('/api/regimen-cards?order-id=' + orderId, {
  //     method: 'GET',
  //     headers: {
  //       'Accept': 'application/json',
  //       'Content-Type': 'application/json',
  //       'x-auth-token': Api.auth_tokenManager()
  //     }
  //   }).then((response) => {
  //     if (response.status >= 400 && response.status < 500) return;
  //     else if (response.status >= 500) throw new Error("Server error");
  //     else return response.json();
  //   }).then(responseJson => {
  //     if (responseJson && responseJson.regimen !== "") {
  //       this.setState({ editHtml: responseJson.regimen }, () => {
  //         this.renderRegimenCardText();
  //         this.convertToCanvas();
  //       });
  //     } else {
  //       console.log('开始创建图片')
  //       this.setState({ editHtml: "" }, () => {
  //         this.renderRegimenCardText();
  //         this.convertToCanvas();
  //       });
  //     }
  //   }).catch(function (err) {
  //     console.log(err);
  //   });
  // }

  getRegimenCard() {
    this.setState({ editHtml: "" }, () => {
      this.renderRegimenCardText();
      this.convertToCanvas();
    });
  }

  getCustomerInfo() {
    try {
      this.setState({loading: true});
      let user_account_info = localStorage.getItem("user_account_info");
      if(util.isJSON(user_account_info)){
        var responseJson = JSON.parse(user_account_info);
        let _skinType =  responseJson;
        this.setState({
          id: responseJson.id,
          name: responseJson.name,
          email: responseJson.email,
          phoneNumber: responseJson.phoneNumber,
          photos: responseJson.photos,
          age: responseJson.age,
          skinType: !!responseJson.skinType ? responseJson.skinType.replace("W", "M") : '' ,
          wrinkled: responseJson.skinType.charAt(3) === 'M'? "mature" : "youthful",
          wrinkledType: responseJson.skinType.charAt(3),
          gender: responseJson.gender ? responseJson.gender.option : null,
          ethnicity: responseJson.ethnicity ? responseJson.ethnicity.option : null,
          budget: responseJson.budget !== null ? responseJson.budget.option : responseJson.budget,
          budgetId: responseJson.budget !== null ? responseJson.budget.id : responseJson.budget,
          recommendedProducts: responseJson.recommendedProducts,
          skinConcerns: responseJson.skinConcerns,
          skinConcernsId: responseJson.skinConcerns.map((concern) => { return concern.id }),
          allergicIngredients: responseJson.allergicIngredients,
          allergiesId: responseJson.allergicIngredients.map((allergy) => { return allergy.id }),
          productTypesRender: responseJson.productTypes,
          loadingDone: true,
        }, () => {
    
          const skinType = this.state.skinType;
          const dryOily = !this.state.skinType ? null : (skinType.charAt(0) !== 'O' && skinType.charAt(0) !== 'C') && skinType.charAt(0) !== 'D' ? null : (skinType.charAt(0) === 'O' ? "oily" : (skinType.charAt(0) === 'C' ? "combination" : "dry"));
          const sensitiveResistant = !this.state.skinType ? null : skinType.charAt(1) !== 'S' && skinType.charAt(1) !== 'R' ? null : (skinType.charAt(1) === 'S' ? "sensitive" : "non-sensitive");
          const pigmented = !this.state.skinType ? null : skinType.charAt(2) !== 'H' && skinType.charAt(2) !== 'L' ? null : (skinType.charAt(2) === 'H' ? "pigmented" : "non-pigmented");
          
    
          this.setState({
            dryOily,
            sensitiveResistant,
            pigmented,
            // wrinkled,
            showDummyDiv: true
          })
          if(!!this.state.selectedOrderForRegimenCard && !!this.state.sourceOrderId ){
            this.getRegimenCard()
          }else{
            this.getCustomerOrderHistory()
          }
        }); // end 
      }else{
        this.setState({loading: false});
        
      }
    } catch (error) {
        this.getCustomerInfo_2();
    }
    
  }



  getCustomerInfo_2(callback) {
    // if (localStorage.getItem("user_id")) localStorage.removeItem("user_id");
    // const email = localStorage.getItem('customer_email');
    this.setState({loading: true});
    const email = this.state.customerEmail;
    const url = '/api/user-account-info?email=' + email;
    fetch(url, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-auth-token': Api.auth_tokenManager()
        }
    })
    .then((response) => response.json())
    .then(responseJson => {
        // localStorage.setItem("user_id", responseJson.id);
        this.setState({
            id: responseJson.id,
            name: responseJson.name,
            pregnancy: responseJson.pregnancy,
            email: responseJson.email,
            phoneNumber: responseJson.phoneNumber,
            photos: responseJson.photos,
            age: responseJson.age,
            skinType: responseJson.skinType.replace("W","M"),
            wrinkled: responseJson.skinType.charAt(3) === 'M'? "wrinkles" : "youthful",
            wrinkledType: responseJson.skinType.charAt(3),
            gender: responseJson.gender ? responseJson.gender.option : null,
            ethnicity: responseJson.ethnicity ? responseJson.ethnicity.option : null,
            budget: responseJson.budget !== null ? responseJson.budget.option : responseJson.budget,
            budgetId: responseJson.budget !== null ? responseJson.budget.id : responseJson.budget,
            recommendedProducts: responseJson.recommendedProducts,
            skinConcerns: responseJson.skinConcerns,
            skinConcernsId: responseJson.skinConcerns.map((concern) => { return concern.id }),
            allergicIngredients: responseJson.allergicIngredients,
            allergiesId: responseJson.allergicIngredients.map((allergy) => { return allergy.id }),
            productTypesRender: responseJson.productTypes,
            loadingDone: true,
            brands: responseJson.brands,
        }, ()=>{
            const skinType = this.state.skinType;
            const dryOily = !this.state.skinType ? null : (skinType.charAt(0) !== 'O' && skinType.charAt(0) !== 'C') && skinType.charAt(0) !== 'D' ? null : (skinType.charAt(0) === 'O' ? "oily" : (skinType.charAt(0) === 'C' ? "combination" : "dry"));
            const sensitiveResistant = !this.state.skinType ? null : skinType.charAt(1) !== 'S' && skinType.charAt(1) !== 'R' ? null : (skinType.charAt(1) === 'S' ? "sensitive" : "non-sensitive");
            const pigmented = !this.state.skinType ? null : skinType.charAt(2) !== 'H' && skinType.charAt(2) !== 'L' ? null : (skinType.charAt(2) === 'H' ? "pigmented" : "non-pigmented");
            this.setState({
              dryOily,
              sensitiveResistant,
              pigmented,
              // wrinkled,
              showDummyDiv: true
            })
            if(!!this.state.selectedOrderForRegimenCard && !!this.state.sourceOrderId ){
              this.getRegimenCard()
            }else{
              this.getCustomerOrderHistory()
            }
      });


    }).catch(function(err) {
        alert("There was a problem retrieving customer data: " + err);
    });
}

  submitOrderCard(imageBase64) {
    // const img = imageBase64.replace('data:image/png;','')
    const sourceOrderId = this.state.sourceOrderId;
    // localStorage.setItem("orderRegimenCard", JSON.stringify({"orderId": `${sourceOrderId}`,"imageBase64": imageBase64,"userEmail":localStorage.getItem("user_global_email")}) )
    const url = '/api/order-card';
    fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        // 'x-auth-token': Api.auth_tokenManager()
      },
      body: JSON.stringify({
        "orderId": `${sourceOrderId}`,
        "imageBase64": imageBase64,
        "userEmail":localStorage.getItem("user_global_email") ? localStorage.getItem("user_global_email") : this.state.contactInformation_email

      })
    })
      // .then((response) => response.json())
      .then(responseJson => {
        // console.log(responseJson)
        localStorage.setItem("orderRegimenCard",true);
        this.cancelLoading(true)
      }).catch(function (err) {
        this.setState({loading: true});
        alert("There was a problem retrieving customer data: " + err);
      });
  }

  convertToCanvas() {
    // this.setState({ showDummyDiv: true });
    const _that = this

    let element = document.getElementById("regimen-card-dummy");
    let options = {
      scale: 2.55
    };
    html2canvas(element, options)
      .then((canvas) => {
        let dataURL = canvas.toDataURL('image/png', 0.3);
        dataURL = dataURL.replace('data:image/png;base64,', '');
        this.submitOrderCard(dataURL);
        // this.setState({
        //     imageURL: dataURL
        // }, function() {
        //     this.setState({
        //         showDummyDiv: true
        //     });
        // });

        // if (this.state.imageURL !== '') {
        //     this.onOpenRegimenModal();
        //     this.setState({ showDummyDiv: false });
        // }
      })
      .catch((err) => {
        _that.cancelLoading()
        alert("Error saving card.");
      });
  }

  getCustomerOrderHistory(callback) {
    const userId = localStorage.getItem("user_id");
    const _that = this
    fetch('/api/user-orders/extended-with-products?user-id=' + userId, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-auth-token': Api.auth_tokenManager()
      }
    }).then((response) => response.json()).then(responseJson => {
      if(responseJson && !!responseJson && responseJson != null){
        this.setState({
          selectedOrderForRegimenCard: responseJson[0].productList,
          sourceOrderId: responseJson[0].userOrderDTO.sourceOrderId,
          orderForInfo: responseJson[0],
        },()=>{
          this.getRegimenCard()
        });
      }
    }).catch(function (err) {
      _that.cancelLoading()
      console.log("There was a problem getting the order history: " + err);
    });
  }

  generateQuote() {
    const randomIndex = Math.floor(Math.random() * ((quoteArr.length - 1) - 0 + 1));
    return quoteArr[randomIndex];
  }

  render() {
    return (
      <div className=" no-steps-header">
        <Helmet>
          <title>Recommendations - HelloAva</title>
        </Helmet>

        {
          this.state.loading ?

            <div name="loadingInfo" style={(this.state.loading) ? { display: "block" } : { display: "none" }}>
              <LoadingBlock purchase={this.state.loading}  isOrder={this.state.isOrderValue}/>
            </div> :

            <div className="thank-you-area">
				<div className="thank-you-hello-area">
					<div className="h3-title">Your goodies are on  <Responsive minWidth={ 769 }><br></br></Responsive>  their way! </div>
					<div className="thank-you-hello-text navy">Your order is confirmed. We know waiting is the hardest part, so our team is working to get this shipped out to you ASAP.</div>
					<div className="thank-you-hello-text navy tow-row">If you have any questions on how to use the products, you can always text your skin advisor or <a href="https://calendly.com/helloavaconsults" target={ util.isMobile(navigator.userAgent) ? "_self" : "_blank" }  className="schedule-consult-function">schedule the next consult</a>.</div>
					<div className="thank-you-hello-img-agea">
						<img className="helloavaIcon" src="/images/thankYou/helloavaIcon.png"></img>
						<img className="teamAutograph" src="/images/thankYou/HelloAvaTeam.svg"></img>
					</div>
				</div>

				<Responsive minWidth={ 769 }>
					<div className="free-skincare-area" onClick={()=>{  this.props.history.push("/referral") }}>
						<img className="skincare" src="/images/thankYou/skincare.png"></img>
						<div className="free-skincare-area-text">
							<div className="paragraphBold1 navy">Earn $20 in free skincare</div>
							<div className="paragraphRegular3 navy">Send friends $20. <br/> Get $20 yourself. That’s what best friends do!</div>
						</div>
					</div>
				</Responsive>

				<Responsive maxWidth={ 769 }>
					<div className="free-skincare-area" onClick={()=>{  this.props.history.push("/referral") }}>
						<div className="free-skincare-area-text">
							<div className="paragraphBold1 navy">Earn $20 in free skincare</div>
							<div className="paragraphRegular5 navy">Send friends $20. <br/> Get $20 yourself. That’s what best friends do!</div>
						</div>
						<img className="skincare" src="/images/thankYou/free-mobile.png"></img>
					</div>
				</Responsive>

				<div>
					{
						localStorage.getItem("auth_token") ?
						<div className="new-final-thank-you-buttons">
								<a href="/orders"><button className="new-button-style">Order history</button></a>
								<a href="/recommendations"><button className="new-button-style">Recommendations</button></a>
						</div>:null
					}

					<div className="social-icons">
						<div className="follow paragraphRegular2 navy">Stay in touch for daily skincare tips</div>
						<div className="social-icon-group">
							<a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/HelloAVAbeauty/"> <i className="fa fa-facebook fa-fw"></i>  </a>
							<a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/helloavabeauty/"> <i className="fa fa-instagram fa-fw"></i> </a>
						</div>
					</div>
				</div>
            </div>

          // <div className="recommendations-container">
          //     <div id="final-thank-you" className="checkout-block final-thank-you-block new-free-thank-area" style={{border:0}}>
          //       <p className="heading_alt2 f-title-name">{localStorage.getItem("user_global_firstname")}, you did it!</p>
          //       <p className="paragraphRegular4 f-y-info">Your order will take about 1-2 days to process. </p>
          //       <div className="free-info-img">
          //         <img src="/images/thankYou/free.png" onClick={()=>{ this.props.history.push('/referral')  }}></img>
          //       </div>


                // {
                //   localStorage.getItem("auth_token") ?
                //   <div className="final-thank-you-buttons">
                //     <div className="checkout-block-button" >
                //       <button><a href="/orders">Order history</a></button>
                //     </div>
                //     <div className="checkout-block-button" >
                //       <button><a href="/recommendations">Recommendations</a></button>
                //     </div>
                // </div>:null
                // }

          //       <div className="social-icons">
          //         <div className="follow">Follow us:</div>
          //         <div className="social-icon-group">
          //           <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/HelloAVAbeauty/">  <i className="fa fa-facebook-square" aria-hidden="true" style={{fontSize:'2.3em'}}></i> </a>
          //           <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/helloavabeauty/"> <i className="fa fa-instagram" aria-hidden="true"  style={{fontSize:'2.3em'}}></i> </a>
          //         </div>
          //       </div>
          //     </div>
          //   </div>

        }

        
        {
          this.state.orderEnd ?
            <div>
              <img src={`https://www.shareasale.com/sale.cfm?tracking=${this.state.orderId}&amount=${this.state.orderSubtotal}&merchantID=77400&transtype=sale&sscidmode=6&sscid=${Api.fun_shareasaleGetCookie()}`} width="1" height="1" />
              <script defer async type="text/javascript" src="https://shareasale-analytics.com/j.js"></script>
            </div> : <div></div>
        }

        {
          this.state.showDummyDiv ?
            <div id="regimen-card-dummy" className="regimen-card-dummy regimen-card-dummy-auto">

              <div className="card-right">
                <div className="card-right-logo">
                  <img alt="HelloAva" src="/images/logo.png" />
                </div>
                <div className="card-right-block card-right-top">
                  <div className="shadow-style"></div>
                  <div className="card-right-top-section-1">
                    <div className="card-right-title">Made for</div>
                    <div className="card-right-name"> { localStorage.getItem("auth_token") ? util.capitalize(this.state.name.toString()) : this.state.contactInformation_firstName +" "+this.state.contactInformation_lastName   } </div>

                    
                  </div>
                  {/*                                     
                        <div className="card-right-top-section-2">
                            <div className="section-2-section skin-type-section">
                                <div className="card-right-title">Skin type</div>
                                <div className="card-skin-type">{ this.state.skinType }</div>
                            </div>
                            <div className="section-2-section social">
                                Join your community by tagging #HELLO{ this.state.skinType.replace("W","M").toLowerCase() } and see what’s working for your fellow { this.state.skinType.replace("W", "M") }s, also tag @helloavabeauty to get featured
                            </div>
                        </div> */}
                  {
                    localStorage.getItem("auth_token") ?
                    <div className="card-right-top-section-3">
                      <div className="card-right-title-skin-type-solid"></div>
                      <div className="card-right-title-skin-type">Skin type</div>
                      {
                        this.state.skinImageExists ?
                          <div className="skin-type">
                            <img
                              alt={this.state.skinType ? this.state.skinType : "Your skin type"}
                              className="full-skin-type"
                              src={"/images/customerType/" + this.state.skinType + ".svg"}
                              onError={() => this.setState({ skinImageExists: false })}
                            />
                          </div> :
                          <div className="skin-type cust-t-skintype-area">
                            <div className="column">
                              <img alt={this.state.dryOily} src={"/images/onboarding/skintypeupdated/" + this.state.dryOily + ".svg"} />
                              <div className="type">{this.state.dryOily}</div>
                            </div>
                            <div className="column">
                              <img alt={this.state.sensitiveResistant} src={"/images/onboarding/skintypeupdated/" + this.state.sensitiveResistant + ".svg"} />
                              <div className="type">{this.state.sensitiveResistant}</div>
                            </div>
                            <div className="column">
                              <img alt={this.state.pigmented} src={"/images/onboarding/skintypeupdated/" + this.state.pigmented + ".svg"} />
                              <div className="type">{this.state.pigmented}</div>
                            </div>
                            <div className="column">
                              {/* <img alt={this.state.skinType.charAt(3) === 'M' ? "wrinkle-prone" : "youthful"} src={"/images/onboarding/skintypeupdated/" + this.state.wrinkled + ".svg"} />
                              <div className="type">{this.state.skinType.charAt(3) === 'M' ? "mature" : "youthful"}</div> */}
                                <img alt={ this.state === 'M'? "mature" : "youthful"  } src={ "/images/onboarding/skintypeupdated/" +  this.state.wrinkled + ".svg" } />
                                <div className="type">{ this.state.wrinkledType === 'M'? "mature" : "youthful" }</div>
                            </div>
                          </div>
                        }
                    </div>:null
                  }

                  {/* <div className="card-right-top-section-4">
                    <div className="card-right-top-section-4-text">
                      Join our community by following and tagging @helloavabeauty and use the hashtag #HELLOAVA to get featured
                            </div>
                  </div> */}
                </div>
                <div className="card-right-block card-right-middle">
                 <div className="shadow-style"></div>
                  <div className="card-right-title">Your regimen</div>
                  <ContentEditable
                    html={this.state.editHtml}
                    disabled={true}
                    onChange={this.handleEditInputChange}
                  />
                </div>
                <div className="card-right-block card-right-bottom">
                 <div className="shadow-style"></div>
                  <div className="card-right-bottom-section-1">
                    <div className="card-right-title curtedby-helloava">Curated by</div>
                    <div className="card-right-title-conten-text">HelloAva</div>
                  </div>
                  <div className="card-right-bottom-section-2">
                    <div className="card-right-title made-on">Made on</div>
                    <div className="card-right-title-conten-text">{getTodayDate()}</div>
                  </div>
                </div>
              </div>
            </div>
            // <ShareModuleDummyDiv
            //     name={userFirstName}
            //     skinTypeAcronym={skinType}
            //     dryOily={dryOily}
            //     sensitiveResistant={sensitiveResistant}
            //     pigmented={pigmented}
            //     wrinkled={wrinkled}
            //     genderId={this.state.selectedGenderId}
            //     summary={this.state.description}
            // /> : null
            : null
        }
      </div>
    )
  }
}
export default showThankYou; 


// WEBPACK FOOTER //
// ./src/views/showThankYous/showThankYouAA.js